
import { mapState } from 'vuex'
import Router from 'vue-router'
import {
  LangEnum,
  CountryList,
  CountryLang,
  SFExpressSupportLangs,
  applyLangBaseList,
} from '@/utils/constBase'
import { linkPath, getPathInfo } from '@/utils/utils'
import allUrls from '@/utils/config'
import { fontFamilyLangMap } from '@/utils/const/countryLang'
// 选择类型
const selectType = {
  lang: 'lang',
  site: 'site',
}
export default {
  components: {},
  data() {
    return {
      LangBaseList: [],
      CountryList,
      site: '',
      visible: false,
      // 移动端 选择
      mbSelectType: selectType.site,
      selectType,
      currentSite: {},
      isNoApply: false,
      isNoApplyList: [],
      traditionalNames: [
        'site-lang-support-customsClearance-apply',
        'site-lang-support-customsClearance-apply-detail',
        'site-lang-support-customsClearance-apply-historyTable',
      ],
      redirectTimer: null,
    }
  },
  computed: {
    ...mapState({
      isAgree: (state) => state.cookie_agree.agree,
      headerHeight: (state) => state.headerHeight,
    }),
    getCountryList() {
      // 过滤掉暂时隐藏的国家列表入口
      const resList = this.CountryList.filter((item) => {
        if (!process.client) return true
        // 避免服务端报错
        if (
          typeof window === 'undefined' ||
          typeof window.getHiddenCountryList !== 'function'
        ) {
          return true
        }
        const hiddenList = window.getHiddenCountryList()
        return !hiddenList || !hiddenList.includes(item.key)
      })
      return resList
    },
    isEnLang() {
      return this.$route.params.lang === 'en'
    },
  },
  watch: {
    $route: {
      handler(newRoute) {
        const lang = this.$route.params.lang

        if (lang === 'tc' && !this.traditionalNames.includes(newRoute.name)) {
          // 清除之前的定时器，避免重复
          if (this.redirectTimer) {
            clearTimeout(this.redirectTimer)
          }

          this.redirectTimer = setTimeout(() => {
            if (typeof window !== 'undefined') {
              const currentUrl = window.location.href
              const newStr = currentUrl.replace('/tc/', '/sc/')

              // 添加条件避免死循环
              if (currentUrl !== newStr) {
                window.location.href = newStr
              }
            }
          }, 0)
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.init()
  },
  activated() {
    // 解决部分场景真机回退时站点和语言不匹配的问题
    this.init()
  },
  beforeDestroy() {
    // 关键：清理定时器
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer)
      this.redirectTimer = null
    }
  },
  methods: {
    // 浮层挂回 header 内，使鼠标移入浮层时 .top_component 的 :hover 仍成立（与 pc.vue 菜单行为一致）
    getHeaderContainer(triggerNode) {
      return triggerNode.closest('.top_component') || document.body
    },
    init() {
      const site = this.$route.params.site
      const lang = this.$route.params.lang
      this.LangBaseList = CountryLang[site]?.lang || []
      this.site = site
      // this.$route.name !== 'site-lang-support-customsClearance-apply'
      if (!this.traditionalNames.includes(this.$route.name)) {
        // this.LangBaseList = this.LangBaseList.map(item => {
        //   if( item.code !== 'tc' ){
        //      return item
        //   } else {
        //      return { ...item, isNoDisable: true }
        //   }
        // })
        this.LangBaseList = this.LangBaseList.filter((item) => {
          if (item.code !== 'tc') {
            return item
          }
        })
      }

      this.mbSelectType = {
        site,
        lang,
      }
      this.filterSf(site)
      if (process.client) {
        this.setFontFamily(lang)
      }
    },
    // 移动端 展示
    showDrawer() {
      this.visible = true
    },
    // 移动端 关闭
    onClose() {
      this.visible = false
    },
    // 选择 国家或者 语言
    selectTypeHandle(type) {
      this.mbSelectType = type
    },
    // 选择 国家
    selectSiteHandle(item) {
      // this.$logger.customTrack({
      //   type: 'click',
      //   event: 'select_region_click|选择国家地区点击率',
      // })
      this.changeCountry({
        key: item.key,
      })
    },
    // 选择 语言
    selectLangHandle(item) {
      // this.$logger.customTrack({
      //   type: 'click',
      //   event: 'change_language_click|切换语言点击率',
      // })
      this.changeLocal({
        key: item.key,
      })
    },
    // 切换路由更改
    routeChange(params = {}, type) {
      const routerInfo = this.$route
      const site = params.site || routerInfo.params.site
      const lang = params.lang || routerInfo.params.lang
      const inSiteList = window.getInSiteList() || []
      if (type === 'country') {
        let url = ''
        let curSiteExpress = ''
        let curSiteIntel = ''
        if (site === 'ex') { // 大网
          curSiteExpress = 'cn'
          url = allUrls.sfExpressUrl + '/' + curSiteExpress + '/' + lang + '/'
          window.open(url, '_blank')
        } else if (site === 'hk') {// 香港/澳门站点直接跳转香港站点真实地址，不再依赖 sfExpressUrl 重定向
          // 语言映射：简体→sc，繁体→tc，其他→en
          let hkLang = 'en'
          if (lang === 'sc') {
            hkLang = 'sc'
          } else if (lang === 'tc') {
            hkLang = 'tc'
          }
          url = allUrls.sfExpressHkUrl + '/hk/' + hkLang + '/'
          window.open(url, '_blank')
        } else if (site === 'tw') {
          // 台湾没有简体
          curSiteExpress = site === 'ex' ? 'cn' : site
          const twLang = lang === 'sc' ? 'tc' : 'en'
          url = allUrls.sfExpressUrl + '/' + curSiteExpress + '/' + twLang + '/'
          window.open(url, '_blank')
        } else if (inSiteList.includes(site)) {
          // 站内跳转
          this.currentCountry(site, lang)
        } else if (site === 'sf') {
          this.currentCountry('cn', lang)
        } else {
          curSiteIntel = site === 'sf' ? 'zh' : site + '/' + lang + '/'
          url = allUrls.owtOldUrl + '/' + curSiteIntel
          window.open(url, '_blank')
        }
      } else {
        const { pathStr } = getPathInfo(routerInfo)
        const path = linkPath({ ...routerInfo.params, ...params }, pathStr, {
          query: routerInfo.query,
          hash: routerInfo.hash,
        })
        // 重新加载资源
        location.replace(path)
      }
    },
    // 国家切换
    changeCountry(l) {
      const countryCode = l.key
      const curLang = this.$route.params.lang
      const curCountryCode = this.$route.params.site
      // 避免重复
      if (countryCode !== curCountryCode) {
        // this.LangBaseList = CountryLang[countryCode]?.lang
        const langList =
          CountryLang[countryCode]?.lang?.map((it) => it.code) || []
        const params = {
          site: countryCode,
          lang:
            langList.find((it) => it === curLang) || SFExpressSupportLangs.en,
        }
        // 判断是否需要保留当前语言
        if (!this.LangBaseList.some((item) => item.code === curLang)) {
          Object.assign(params, { lang: this.LangBaseList[0].code })
        }
        this.routeChange(params, 'country')
      }
    },
    // 语言切换
    changeLocal(l) {
      const lang = this.$route
      // this.$route.name !== 'site-lang-support-customsClearance-apply'
      if (
        l.key == 'zh-TW' &&
        !this.traditionalNames.includes(this.$route.name)
      ) {
        return
      }
      const locale = l.key
      const curLang = this.$route.params.lang
      console.log('curLang---', curLang)
      const langCode = LangEnum[locale].code
      // 避免重复
      if (curLang !== langCode) {
        this.$i18n.locale = locale
        this.routeChange(
          {
            lang: langCode,
          },
          'lang'
        )
      }
    },
    addOrReduceFont(font, FONT_MINE) {
      const fonts = font.split(',')
      if (FONT_MINE && !fonts.includes(FONT_MINE)) {
        fonts.unshift(FONT_MINE)
      }
      return fonts.join(',')
    },
    setFontFamily(lang) {
      const body = document.body
      const font = body.currentStyle
        ? body.currentStyle['font-family']
        : getComputedStyle(body, null)['font-family']
      if (fontFamilyLangMap[lang]) {
        body.style.fontFamily = this.addOrReduceFont(
          font,
          fontFamilyLangMap[lang]
        )
      }
    },
    filterSf(site) {
      if (site === 'cn') {
        this.CountryList = CountryList.filter((it) => it.key !== 'sf')
      }
    },
    currentCountry(site, lang) {
      window.location.href = `${window.location.origin}/${site}/${lang}`
    },
    getCurrentSiteName(site) {
      return CountryList.find((it) => it.key === site)?.name || ''
    },
  },
}
